import { render, staticRenderFns } from "./MessagePhotoUpload.vue?vue&type=template&id=f3566070&"
import script from "./MessagePhotoUpload.vue?vue&type=script&lang=js&"
export * from "./MessagePhotoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports